import { Icon, IconButton, Tooltip } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import Input from "../../components/Input";
import MetricsCard from "../../components/MetricsCard";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import StatusAlert from "../../components/StatusAlert";
import { Reducers } from "../../Interfaces/Interfaces";
import { getTradePartnerLocation } from "../../redux/actions/AggregatorAction";
import { getCoordinatorTransactionDashboard } from "../../redux/actions/CoordinatorActions";
import { getTransactionDashboard } from "../../redux/actions/DashboardActions";
import {
  assignMultipleTerminal,
  assignTerminal,
  getAggregatorAgents,
  getCoordinatorTerminals,
  getTerminals,
  retrieveTerminal,
  toggleTerminalState,
} from "../../redux/actions/POSAction";
import { getPOSDashboard } from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";

import PosMapTerminal from "../POS/PosMapTerminal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
export default function LocationDetails() {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state: Reducers) => state.user);
  const { enqueueSnackbar } = useSnackbar();
  const alert = useSelector((state: Reducers) => state.alert);
  const agents = useSelector((state: Reducers) => state.agents);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const terminals = useSelector((state: Reducers) => state.terminals);
  const userType = useSelector((state: Reducers) => state.userType);
  const loader = useSelector((state: Reducers) => state.internalLoader);
  // const coordinatorType = useSelector((state: Reducers) => state.coordinatorType);

  const [searchState, setSearchState] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [pin, setPin] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [terminal, setTerminal]: any = React.useState("");
  const [comment, setComment]: any = React.useState("");
  const [title, setTitle]: any = React.useState("");
  const [item, setItem]: any = React.useState("");
  const [subtitle, setSubtitle]: any = React.useState("");
  const [agent, setAgent]: any = React.useState("");
  const [agentId, setAgentId]: any = React.useState("");
  const [type, setType] = React.useState(0); // retrieve = 1, start = 2, stop = 4, assign = 3, multiple=5
  const [submitted, setSubmitted] = React.useState(false);
  const [posState, setPosState]: any = React.useState(0);
  const [targetStatus, setTargetStatus]: any = React.useState(0);
  const [groupTerminal, setgroupTerminal] = useState(false);
  const [multipleTerminal, setmultipleTerminal]: any = useState([]);
  const [transPeriod, setTransPeriod] = React.useState(1);
  const [transLoading, setTransLoading] = React.useState(false);
  const [rangeState, setrangeState] = React.useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const getRegionsData: any = {
    data: [
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 5849,
        expTransfer: 4758,
        lastActive: "3 months ago",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 4849,
        expTarget: 5789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
      {
        name: "Ahmed Ade",
        phone: "08034758384",
        state: "Yobe",
        tnx: "1490",
        aclTarget: 5849,
        expTarget: 4789,
        actTransfer: 3849,
        expTransfer: 4758,
        lastActive: "12:04",
      },
    ],

    totalItemCount: 11,
  };
  let list = getRegionsData && getRegionsData.data;
  let agentList = agents && agents.result;

  let filter: any = {};
  let filterTransaction = { period: transPeriod };
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    if (userType === "5") {
      // dispatch(getPOSDashboard(user.id));
      dispatch(getTerminals(paginationConfig));
    }
  };

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/location");
  };

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setPosState(0);
    setTargetStatus(0);

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    if (userType === "5") {
      dispatch(getTerminals(paginationConfig));
    }
  };

  const callTerminals = () => {
    if (userType === "5") {
      dispatch(getTerminals(paginationConfig));
      dispatch(getAggregatorAgents(user.id));
    } else {
      dispatch(getCoordinatorTerminals(paginationConfig));
    }
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    setPageSize(value.props.value);
    paginationConfig.pageSize = value.props.value;
    callTerminals();
  };

  // filters
  React.useEffect(() => {
    if (posState !== 0) {
      filter.locationId = posState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      callTerminals();
    }

    if (searchState.length > 3) {
      filter.searchText = searchState;

      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      callTerminals();
    }

    if (targetStatus !== 0) {
      filter.targetStatus = targetStatus;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      callTerminals();
    } else {
      callTerminals();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posState, dispatch, targetStatus, searchState]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    callTerminals();

    return () => {
      dispatch({
        type: "TERMINALS",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setSubmitted(false);
        setLoading(false);
      } else {
        setPin("");
        setComment("");

        if (alert.message === "Successful") {
          callTerminals();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert]);

  const [tofalse, settofalse]: any = useState({
    id: "",
  });

  const handleSelect = (date: any) => {
    setrangeState([date.selection]);

    filter.dateCreatedFrom = date.selection.startDate;
    filter.dateCreatedTo = date.selection.endDate;
    paginationConfig.whereCondition = JSON.stringify(filter);

    // dispatch({ type: "LOADING", payload: true });
    callTerminals();
  };
  React.useEffect(() => {
    dispatch(getTradePartnerLocation());
  }, []);
  const getColor = (actual: any, totalTerget: any) => {
    if (actual > totalTerget) {
      return "badge-success";
    } else {
      return "badge-danger";
    }
  };
  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar canGoBack />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            height: "100vh",
            position: "relative",

            // zIndex: 1000,
          }}
        >
          <h1
            className="mb-5 pos-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
              background: "inherit",
            }}
          >
            {" "}
            Location Region{" "}
          </h1>

          <div className="row">
            <div className="col-md-12  mb-3" style={{ paddingBottom: "100px" }}>
              <Tabs>
                <TabList>
                  <Tab>Agents</Tab>
                  <Tab>Trade Partners</Tab>
                  <Tab>Sales Manager</Tab>
                  <Tab>Regional Manager</Tab>
                </TabList>

                <TabPanel>
                  <div style={{ marginBottom: "20px" }}>
                    <Filters
                      searchState={searchState}
                      handleSearch={(e: any) => setSearchState(e.target.value)}
                      posStateChange={(e: any) => setPosState(e.target.value)}
                      posState={posState}
                      posTarget={targetStatus}
                      posTargetChange={(e: any) =>
                        setTargetStatus(e.target.value)
                      }
                      isLocationDetails
                      handleSelect={(item: any) => handleSelect(item)}
                      poshasStatus
                      onClear={handleClear}
                      ranges={rangeState}
                    />
                  </div>
                  {list ? (
                    <React.Fragment>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th scope="col">S/N</th>
                              <th scope="col">Name</th>
                              <th scope="col">Phone</th>
                              <th scope="col">State</th>

                              <th scope="col">Total TNX</th>

                              <th scope="col">Pos</th>
                              <th scope="col">Transfer</th>
                              <th scope="col">Last Active</th>
                            </tr>
                          </thead>
                          <tbody>
                            {list.length !== 0 &&
                              list?.map((item: any, index: number) => (
                                <tr
                                  title="Click to view"
                                  key={index}
                                  className="pointer text-center"
                                >
                                  <th scope="row">{getIndexSeed(index)}</th>
                                  <td>{item.name ? item.name : "-"}</td>
                                  <td>{item.phone ? item.phone : "-"}</td>
                                  <td>{item.state ? item.state : "-"}</td>
                                  <td>{item.tnx ? item.tnx : "-"}</td>
                                  <td>
                                    {item.aclTarget && item.expTarget ? (
                                      <button
                                        className={getColor(
                                          item.aclTarget,
                                          item.expTarget
                                        )}
                                        style={{
                                          border: "none",
                                          borderRadius: "26px",
                                          padding: "5px 10px 5px 10px",
                                          fontSize: "12px",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {" "}
                                        {item.aclTarget + "/" + item.expTarget}
                                      </button>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {item.actTransfer && item.expTransfer ? (
                                      <button
                                        className={getColor(
                                          item.actTransfer,
                                          item.expTransfer
                                        )}
                                        style={{
                                          border: "none",
                                          borderRadius: "26px",
                                          padding: "5px 10px 5px 10px",
                                          fontSize: "12px",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {" "}
                                        {item.actTransfer +
                                          "/" +
                                          item.expTransfer}
                                      </button>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {item.lastActive ? item.lastActive : "-"}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {list.length === 0 && (
                        <React.Fragment>
                          <p className="text-center mt-3 text-dark w-100">
                            No result
                          </p>
                        </React.Fragment>
                      )}

                      <div className="col-md-12 p-0">
                        {getRegionsData.totalItemCount > pageSize && (
                          <PaginationControlled
                            onPageSizeChange={handlePageSizeChange}
                            onChange={handleChange}
                            page={page}
                            total={
                              getRegionsData.totalItemCount &&
                              getRegionsData.totalItemCount
                            }
                            pageSize={pageSize}
                          />
                        )}
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                    </React.Fragment>
                  )}
                </TabPanel>
                {/* Trade Partners */}
                <TabPanel>No result</TabPanel>
                {/* sales manager */}
                <TabPanel>No result</TabPanel>
                {/* Regional Manager */}
                <TabPanel>No result</TabPanel>
              </Tabs>
            </div>
          </div>
        </div>

        <StatusAlert
          subtitle={subtitle}
          title={title}
          buttonTitle="Goto POS"
          backTitle="Back to dashboard"
          goBack={goBack}
          onClick={handleRefresh}
        ></StatusAlert>
      </div>
    </React.Fragment>
  );
}
